import React from 'react'

const Yho3 = () => {
    return (
        <div className='container'>
        <h1>Find largest prime factor of a number</h1>
        <p>Given a positive integer ‘n'( 1 &lt;= n &lt;= 10<sup>15</sup>). Find the largest prime factor of a number.</p>
        <pre><strong>Input: </strong>6 <br />
<strong>Output: </strong>3 <br />
<strong>Explanation</strong> <br />
Prime factor of 6 are- 2, 3 <br />
Largest of them is '3' <br />
 <br />
<strong>Input: </strong>15 <br />
<strong>Output: </strong>5 <br />
</pre>
<p>The approach is simple, just factorise the given number by dividing it with the divisor of a number and keep updating the maximum prime factor.<br/></p>

        <div class="tabs">
<input type="radio" name="tab" id="tab1" />
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab4">C</label>


<div class="tab-content-wrapper">
  <div id="tab-content-1" class="tab-content">
  <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C++ Program to find largest prime</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// factor of number</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;iostream&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="preprocessor">#include&lt;bits/stdc++.h&gt;</code></div>
    <div class="line number5 index4 alt2"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number7 index6 alt2"><code class="comments">// A function to find largest prime factor</code></div>
    <div class="line number8 index7 alt1"><code class="color1 bold">long</code> <code class="color1 bold">long</code>
        <code class="plain">maxPrimeFactors(</code><code class="color1 bold">long</code> <code
            class="color1 bold">long</code> <code class="plain">n)</code></div>
    <div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Initialize the maximum prime factor</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// variable with the lowest one</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">long</code> <code class="color1 bold">long</code> <code
            class="plain">maxPrime = -1;</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Print the number of 2s that divide n</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code> <code class="plain">(n % 2 == 0) &#123;</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime = 2;</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n &gt;&gt;= 1; </code><code class="comments">// equivalent to n /= 2</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// n must be odd at this point, thus skip</code></div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// the even numbers and iterate only for</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// odd integers</code></div>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">i = 3; i &lt;= </code><code class="functions bold">sqrt</code><code
            class="plain">(n); i += 2) &#123;</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code> <code class="plain">(n % i == 0) &#123;</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime = i;</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n = n / i;</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// This condition is to handle the case</code></div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// when n is a prime number greater than 2</code></div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(n &gt; 2)</code></div>
    <div class="line number33 index32 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime = n;</code></div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">maxPrime;</code></div>
    <div class="line number36 index35 alt1"><code class="plain">&#125;</code></div>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number38 index37 alt1"><code class="comments">// Driver program to test above function</code></div>
    <div class="line number39 index38 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number40 index39 alt1"><code class="plain">&#123;</code></div>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">long</code> <code class="color1 bold">long</code> <code class="plain">n = 15;</code>
    </div>
    <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; maxPrimeFactors(n) &lt;&lt; endl;</code></div>
    <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n = 25698751364526;</code></div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt;&nbsp; maxPrimeFactors(n);</code></div>
    <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number47 index46 alt2"><code class="plain">&#125;</code></div>
    <div class="line number48 index47 alt1"><code class="comments">// This code is contributed by Shivi_Aggarwal</code>
    </div>
</div>
</div>
  <div id="tab-content-2" class="tab-content">
  <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// Java Program to find largest</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// prime factor of number</code></div>
    <div class="line number3 index2 alt2"><code class="keyword">import</code> <code class="plain">java.io.*;</code>
    </div>
    <div class="line number4 index3 alt1"><code class="keyword">import</code> <code class="plain">java.util.*;</code>
    </div>
    <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="keyword">class</code> <code class="plain">NooB &#123;</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// function to find largest prime factor</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">static</code> <code class="keyword">long</code> <code
            class="plain">maxPrimeFactors(</code><code class="keyword">long</code> <code class="plain">n)</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Initialize the maximum prime</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// factor variable with the</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// lowest one</code></div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">long</code> <code class="plain">maxPrime = -</code><code class="value">1</code><code
            class="plain">;</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Print the number of 2s</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// that divide n</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">(n % </code><code class="value">2</code> <code
            class="plain">== </code><code class="value">0</code><code class="plain">) &#123;</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime = </code><code class="value">2</code><code class="plain">;</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// equivalent to n /= 2</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n &gt;&gt;= </code><code class="value">1</code><code class="plain">;</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// n must be odd at this point,</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// thus skip the even numbers</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// and iterate only for odd</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// integers</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">(</code><code class="keyword">int</code> <code
            class="plain">i = </code><code class="value">3</code><code
            class="plain">; i &lt;= Math.sqrt(n); i += </code><code class="value">2</code><code class="plain">) &#123;</code>
    </div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">(n % i == </code><code class="value">0</code><code
            class="plain">) &#123;</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime = i;</code></div>
    <div class="line number32 index31 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n = n / i;</code></div>
    <div class="line number33 index32 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number34 index33 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// This condition is to handle</code></div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// the case when n is a prime</code></div>
    <div class="line number38 index37 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// number greater than 2</code></div>
    <div class="line number39 index38 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(n &gt; </code><code class="value">2</code><code
            class="plain">)</code></div>
    <div class="line number40 index39 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime = n;</code></div>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number42 index41 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">maxPrime;</code></div>
    <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Driver code</code></div>
    <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main(String[] args)</code></div>
    <div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number48 index47 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Long n = 15l;</code></div>
    <div class="line number49 index48 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(maxPrimeFactors(n));</code></div>
    <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number51 index50 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n = 25698751364526l;</code></div>
    <div class="line number52 index51 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(maxPrimeFactors(n));</code></div>
    <div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number54 index53 alt1"><code class="plain">&#125;</code></div>
    <div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number56 index55 alt1"><code class="comments">// This code is contributed by Gitanjali</code></div>
</div>
    </div>
  <div id="tab-content-3" class="tab-content">
  <div class="container">
    <div class="line number1 index0 alt2"><code class="comments"># Python3 code to find largest prime</code></div>
    <div class="line number2 index1 alt1"><code class="comments"># factor of number</code></div>
    <div class="line number3 index2 alt2"><code class="keyword">import</code> <code class="plain">math</code></div>
    <div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number5 index4 alt2"><code class="comments"># A function to find largest prime factor</code></div>
    <div class="line number6 index5 alt1"><code class="keyword">def</code> <code
            class="plain">maxPrimeFactors (n):</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
    </div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Initialize the maximum prime factor</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># variable with the lowest one</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime </code><code class="keyword">=</code> <code class="keyword">-</code><code
            class="value">1</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
    </div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Print the number of 2s that divide n</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">n </code><code class="keyword">%</code> <code
            class="value">2</code> <code class="keyword">=</code><code class="keyword">=</code> <code
            class="value">0</code><code class="plain">:</code></div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime </code><code class="keyword">=</code> <code class="value">2</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n &gt;&gt;</code><code class="keyword">=</code> <code
            class="value">1</code>&nbsp;&nbsp;&nbsp;&nbsp; <code class="comments"># equivalent to n /= 2</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># n must be odd at this point,&nbsp;</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># thus skip the even numbers and&nbsp;</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># iterate only for odd integers</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
            class="functions">range</code><code class="plain">(</code><code class="value">3</code><code
            class="plain">, </code><code class="functions">int</code><code class="plain">(math.sqrt(n)) </code><code
            class="keyword">+</code> <code class="value">1</code><code class="plain">, </code><code
            class="value">2</code><code class="plain">):</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">n </code><code class="keyword">%</code> <code
            class="plain">i </code><code class="keyword">=</code><code class="keyword">=</code> <code
            class="value">0</code><code class="plain">:</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime </code><code class="keyword">=</code> <code class="plain">i</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n </code><code class="keyword">=</code> <code class="plain">n </code><code
            class="keyword">/</code> <code class="plain">i</code></div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
    </div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># This condition is to handle the&nbsp;</code></div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># case when n is a prime number&nbsp;</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># greater than 2</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">n &gt; </code><code class="value">2</code><code
            class="plain">:</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime </code><code class="keyword">=</code> <code class="plain">n</code></div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
    </div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="functions">int</code><code class="plain">(maxPrime)</code></div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number33 index32 alt2"><code class="comments"># Driver code to test above function</code></div>
    <div class="line number34 index33 alt1"><code class="plain">n </code><code class="keyword">=</code> <code
            class="value">15</code></div>
    <div class="line number35 index34 alt2"><code class="keyword">print</code><code
            class="plain">(maxPrimeFactors(n))</code></div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number37 index36 alt2"><code class="plain">n </code><code class="keyword">=</code> <code
            class="value">25698751364526</code></div>
    <div class="line number38 index37 alt1"><code class="functions">print</code><code
            class="plain">(maxPrimeFactors(n))</code></div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number40 index39 alt1"><code
            class="comments"># This code is contributed by "Sharad_Bhardwaj".</code></div>
</div>
 </div>
  <div id="tab-content-4" class="tab-content">
  <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C Program to find largest prime</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// factor of number</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;math.h&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="preprocessor">#include &lt;stdio.h&gt;</code></div>
    <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="comments">// A function to find largest prime factor</code></div>
    <div class="line number7 index6 alt2"><code class="color1 bold">long</code> <code class="color1 bold">long</code>
        <code class="plain">maxPrimeFactors(</code><code class="color1 bold">long</code> <code
            class="color1 bold">long</code> <code class="plain">n)</code></div>
    <div class="line number8 index7 alt1"><code class="plain">&#123;</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Initialize the maximum prime factor</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// variable with the lowest one</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">long</code> <code class="color1 bold">long</code> <code
            class="plain">maxPrime = -1;</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Print the number of 2s that divide n</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code> <code class="plain">(n % 2 == 0) &#123;</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime = 2;</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n &gt;&gt;= 1; </code><code class="comments">// equivalent to n /= 2</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// n must be odd at this point, thus skip</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// the even numbers and iterate only for</code></div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// odd integers</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">i = 3; i &lt;= </code><code class="functions bold">sqrt</code><code
            class="plain">(n); i += 2) &#123;</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code> <code class="plain">(n % i == 0) &#123;</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime = i;</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n = n / i;</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// This condition is to handle the case</code></div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// when n is a prime number greater than 2</code></div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(n &gt; 2)</code></div>
    <div class="line number32 index31 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxPrime = n;</code></div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">maxPrime;</code></div>
    <div class="line number35 index34 alt2"><code class="plain">&#125;</code></div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number37 index36 alt2"><code class="comments">// Driver program to test above function</code></div>
    <div class="line number38 index37 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number39 index38 alt2"><code class="plain">&#123;</code></div>
    <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">long</code> <code class="color1 bold">long</code> <code class="plain">n = 15;</code>
    </div>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code class="string">"%lld\n"</code><code
            class="plain">, maxPrimeFactors(n));</code></div>
    <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n = 25698751364526;</code></div>
    <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code class="string">"%lld"</code><code
            class="plain">, maxPrimeFactors(n));</code></div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number47 index46 alt2"><code class="plain">&#125;</code></div>
</div>
 </div>
 </div>
</div>
<br /> <br /> <br /> <br /> <br />
    </div>
    )
}

export default Yho3
